// libs
import styled, { css } from 'styled-components'
// components
import { Fab } from '@mui/material'
// constants
import { WYSIWIG_CLASS_NAMES } from 'constants/wysiwig'
//themes
import { colors } from 'themes/index'
// icons
import AddAttachmentIconOrigin from 'src/icons/add-attachment.svg'
import AttachmentIconOrigin from 'src/icons/attachment.svg'
import CloseRoundedIcon from '@mui/icons-material/CloseRounded'
import FilterIconOrigin from 'src/icons/filter.svg'
import LinkIconOrigin from 'src/icons/link.svg'
// views
import { ToolbarWrapper } from 'components/FormElements/Wysiwyg/Toolbar/views'
// utils
import { darken, size } from 'polished'

const IconsCSS = css`
  cursor: pointer;
  position: absolute;
  z-index: 99;

  ${size('28px')};

  &:hover {
    path {
      fill: ${darken(0.1, colors.purple500)};
    }
  }
`

const AddAttachmentIcon = styled(AddAttachmentIconOrigin)`
  && {
    ${IconsCSS};

    bottom: 80px;
  }
`

const AttachmentIcon = styled(AttachmentIconOrigin)`
  && {
    margin-right: 4px;
    height: 21px;
    width: 28px;
  }
`

const CloseIcon = styled(CloseRoundedIcon)`
  && {
    cursor: pointer;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 9;
  }
`

const FilterIcon = styled(FilterIconOrigin)`
  && {
    ${IconsCSS};

    bottom: 80px;
    right: 20px;
  }
`
const LinkIcon = styled(LinkIconOrigin)`
  && {
    margin-right: 4px;
    ${size('28px')};
  }
`

const Form = styled.form<{ isCommentEdit?: boolean }>`
  padding: 0 16px;
  z-index: 1;
  position: relative;
  width: 100%;

  .${WYSIWIG_CLASS_NAMES.wrapperClassName} {
    border: none;
    outline: none !important;
  }

  .${WYSIWIG_CLASS_NAMES.editorClassName} {
    border: none;
    border-bottom: 2px solid ${colors.gray210};
    padding: 0;
    transition: transform 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;
    overflow: auto;
    max-height: 100px;

    &:hover {
      border-bottom: 2px solid ${colors.purple800};
    }

    & > div {
      margin: ${({ isCommentEdit }) => (isCommentEdit ? '0' : '0 23px 0 34px')};
    }

    ${({ isCommentEdit }) =>
      isCommentEdit &&
      css`
        & > div > div > div > div > div > div {
          margin-bottom: 4px;
        }
      `}
  }

  .${WYSIWIG_CLASS_NAMES.toolbarClassName} {
    display: flex;
    justify-content: end;
    margin-top: 4px;
    opacity: 0.7;
    padding: 0;

    > div {
      display: flex;
    }

    & > * > * {
      border-radius: 0;
      border: none;
      border-bottom: 1px solid transparent;
      box-shadow: none;
      height: 20px;
      max-height: 20px;
      max-width: 20px;
      min-height: 20px;
      min-width: 20px;
      padding: 0;
      width: 20px;

      &:hover {
        border-bottom: 1px solid ${colors.gray850};
      }
    }
  }
    
  ${ToolbarWrapper} {
    margin-top: 6px;
    border-radius: 8px;
  }
`

const SubmitButton = styled(Fab)`
  && {
    background: ${colors.purple300};
    bottom: 16px;
    box-shadow: none;
    color: ${colors.white100};
    max-height: 28px;
    max-width: 28px;
    min-height: 28px;
    min-width: 28px;
    position: absolute;
    right: 32px;

    &:hover {
      background: ${colors.purple500};
    }
  }
`

export { AddAttachmentIcon, AttachmentIcon, LinkIcon, FilterIcon, Form, SubmitButton, CloseIcon }
